import React from 'react';

const ServiceCard = ({ image, title, description }) => {
  return (
    <div className="bg-white pt-8 ps-8 rounded-xl border border-gray-100 flex items-start gap-8 hover:shadow-lg transition-shadow">
      <div className="w-[150px] flex-shrink-0 self-end">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-auto object-contain object-bottom"
        />
      </div>
      
      <div className="flex-1 pb-5">
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        
        {/* <div 
          className="flex items-center gap-3 cursor-pointer group"
        >
          <span className="text-lg custom-font">Learn More</span>
          <img 
            src="/assets/icons/right-arrow.svg" 
            alt="right arrow" 
            className="w-15 h-15 transition-transform duration-300 group-hover:translate-x-1"
          />
        </div> */}
      </div>
    </div>
  );
};

export default ServiceCard;